import { isNil } from 'ramda';
import React from 'react';
import { InjectedPropsModifier } from '../../../Core/InjectedPropsContext';

const replaceWaterContentWithMoistureContent = (original: string) =>
  original.replace(
    /\b(w)ater(?= content\b)/i,
    (_: string, p1: string) => `${p1 === p1.toUpperCase() ? 'M' : 'm'}oisture`
  );

/**
 * Modifier to transform the terminology of the ASTM worksheet to AASHTO terminology
 *
 * Handy to avoid configuring headings/etc without field names,
 * because we are only doing a find-and-replace of an otherwise identical test.
 */
export const PsdAashtoTerminologyModifier: React.FC<React.PropsWithChildren> = ({ children }) => (
  <InjectedPropsModifier
    propModifier={(consumerProps: any) => {
      if (!isNil(consumerProps.label)) {
        consumerProps.label = replaceWaterContentWithMoistureContent(consumerProps.label);
      }

      if (!isNil(consumerProps.heading)) {
        consumerProps.heading = replaceWaterContentWithMoistureContent(consumerProps.heading);
      }
    }}
  >
    {children}
  </InjectedPropsModifier>
);
